import { render, staticRenderFns } from "./PercentChange.vue?vue&type=template&id=76b12dbc"
import script from "./PercentChange.vue?vue&type=script&lang=js"
export * from "./PercentChange.vue?vue&type=script&lang=js"
import style0 from "./PercentChange.vue?vue&type=style&index=0&id=76b12dbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports